module.exports = __webpack_public_path__ + "static/media/cole_presenting_graph_in_background.8ff15afb.png";